/* POWKONG Plantdock 2 animated A+ — scroll-reveal + parallax + sticky buy bar */
(function(){
  function init(){
    // scroll reveal
    var els=document.querySelectorAll('.pk-ap .rv,.pk-ap .rv-l,.pk-ap .rv-r,.pk-ap .pop');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
      },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
      els.forEach(function(el){ io.observe(el); });
    } else { els.forEach(function(el){ el.classList.add('in'); }); }

    // parallax floats
    var floats=[].slice.call(document.querySelectorAll('.pk-ap [data-parallax]'));
    var ticking=false;
    function onScroll(){
      if(!ticking){ window.requestAnimationFrame(function(){
        var y=window.scrollY||window.pageYOffset;
        floats.forEach(function(f){
          var sp=parseFloat(f.getAttribute('data-parallax'))||0.1;
          var r=f.getBoundingClientRect(); var mid=r.top+window.scrollY;
          var d=(y-mid+window.innerHeight*0.5)*sp*-0.25;
          f.style.transform='translateY('+d.toFixed(1)+'px)';
        });
        // sticky buy bar
        if(bar){ bar.classList.toggle('show', y>560 && y<maxShow()); }
        ticking=false;
      }); ticking=true; }
    }
    // sticky buy bar
    var bar=document.querySelector('.pk-ap-buybar');
    function maxShow(){ var f=document.querySelector('.pk-ap-footzone'); return f? (f.offsetTop-400) : 9e9; }
    function scrollToBuy(){
      var t=document.querySelector('#MainProduct,.product__info-container,product-form,form[action*="/cart/add"]');
      if(t){ var top=t.getBoundingClientRect().top+window.scrollY-80; window.scrollTo({top:top,behavior:'smooth'}); }
    }
    if(bar){ var c=bar.querySelector('[data-buy]'); if(c){ c.addEventListener('click',function(e){ e.preventDefault(); scrollToBuy(); }); } }
    document.querySelectorAll('.pk-ap [data-buy]').forEach(function(b){ b.addEventListener('click',function(e){ e.preventDefault(); scrollToBuy(); }); });

    
    // per-review text clamp (max 8 lines + Read more). Wire once; (re)measure when visible.
    function wireClamp(p){
      var btn=p.parentNode.querySelector('[data-revexpand]');
      if(!btn) return;
      if(!p.dataset.clampWired){
        p.dataset.clampWired='1';
        btn.addEventListener('click',function(){
          var collapsed=p.classList.toggle('clamp');
          btn.textContent=collapsed?'Read more':'Read less';
        });
      }
      // hidden cards measure 0; only reveal the button when actually overflowing
      if(p.classList.contains('clamp') && btn.hidden && p.scrollHeight > p.clientHeight + 2){ btn.hidden=false; }
    }
    document.querySelectorAll('.pk-ap [data-revtext]').forEach(wireClamp);

    // reviews show-more
    document.querySelectorAll('.pk-ap [data-revmore]').forEach(function(b){
      b.addEventListener('click',function(){
        var sec=b.closest('section')||document;
        sec.querySelectorAll('.revcard.revhidden,.revcard.revhidden-m').forEach(function(c){
          c.classList.remove('revhidden'); c.classList.remove('revhidden-m'); c.classList.add('in');
          var p=c.querySelector('[data-revtext]'); if(p) wireClamp(p);
        });
        b.style.display='none';
      });
    });

    // reviews horizontal carousel arrows (desktop; mobile uses native swipe)
    document.querySelectorAll('.pk-ap [data-revwrap]').forEach(function(track){
      if(track.dataset.navWired) return; track.dataset.navWired='1';
      var sec=track.closest('section')||document;
      function step(dir){ var card=track.querySelector('.revcard'); var w=card?(card.getBoundingClientRect().width+24):track.clientWidth*0.8; track.scrollBy({left:dir*w,behavior:'smooth'}); }
      var pv=sec.querySelector('[data-revprev]'), nx=sec.querySelector('[data-revnext]');
      if(pv) pv.addEventListener('click',function(){ step(-1); });
      if(nx) nx.addEventListener('click',function(){ step(1); });
    });

    // per-review multi-image swipe + dots
    document.querySelectorAll('.pk-ap .rev-photos.multi').forEach(function(track){
      if(track.dataset.dotsWired) return; track.dataset.dotsWired='1';
      var imgs=track.querySelectorAll('.rev-photo'); if(imgs.length<2) return;
      var dots=document.createElement('div'); dots.className='rev-dots';
      for(var i=0;i<imgs.length;i++){ (function(idx){ var d=document.createElement('i'); if(idx===0) d.className='on';
        d.addEventListener('click',function(){ track.scrollTo({left:track.clientWidth*idx,behavior:'smooth'}); }); dots.appendChild(d); })(i); }
      track.parentNode.insertBefore(dots, track.nextSibling);
      var tk=false;
      track.addEventListener('scroll',function(){ if(tk) return; tk=true; window.requestAnimationFrame(function(){
        var idx=Math.round(track.scrollLeft/Math.max(1,track.clientWidth)); var ds=dots.querySelectorAll('i');
        for(var j=0;j<ds.length;j++){ ds[j].classList.toggle('on', j===idx); } tk=false; }); },{passive:true});
    });

    window.addEventListener('scroll',onScroll,{passive:true});
    onScroll();
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
})();
